<template>
  <client-only>
    <v-text-field
      v-model="model"
      :label="!model ? displayUsersPhone : formLabel"
      solo
      type="phone"
      :rules="phoneRules"
      required
      rounded
      outlined
      dir="auto"
      maxlength="10"
      dense
      :error="!isComplete"
      prepend-inner-icon="mdi-cellphone"
    ></v-text-field>
  </client-only>
</template>

<script>
import { includes } from 'lodash';
import { phoneRules } from '@/lib/rules.js';

export default {
  props: {
    fieldClass: {
      type: String,
      required: false,
      default: '',
    },
    currentPhone: {
      type: String,
      required: false,
      default: null,
    },
    showError: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      userPhoneNew: '',
      formLabel: 'טלפון נייד',
      phoneRules,
    };
  },

  computed: {
    model: {
      get() {
        return this.currentPhone;
      },
      set(val) {
        this.userPhoneNew = val;
      },
    },

    displayUsersPhone() {
      return this.currentPhone ? this.currentPhone : this.formLabel;
    },

    isComplete() {
      return (
        !this.showError ||
        (this.showError && this.userPhoneNew && this.userPhoneNew.length > 0)
      );
    },
  },

  watch: {
    userPhoneNew() {
      this.$emit('updateNumber', this.userPhoneNew);
    },
  },

  mounted() {
    if (!includes(this.$route.path, 'signup')) {
      this.isComplete;
    }
    this.userPhoneNew = this.currentPhone;
  },
};
</script>

